import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import { Doughnut } from 'react-chartjs-2';

const Widget6 = props => {
	const options = {
		cutoutPercentage: 66,
		spanGaps: true,
		legend: {
			display: true,
			position: 'bottom',
			labels: {
				padding: 16,
				usePointStyle: true
			}
		},
		maintainAspectRatio: false
	};

	return (
		<Paper className="w-full rounded-8 border-1">
			<div className="flex items-center justify-center px-16 h-62 border-b-1">
				<Typography className="text-18 font-bold">{props.title}</Typography>
			</div>
			<div className="h-400 w-full">
				{props.data.datasets[0].data.reduce((a, b) => a + b, 0) !== 0 ? (
					<Doughnut data={props.data} options={{ ...options, ...props.options }} />
				) : (
					<div className="flex flex-1 items-center justify-center h-full">
						<Typography className="font-bold" id="no-clusters-msg" color="textSecondary" variant="h5">
							{`No ${props.title}`}
						</Typography>
					</div>
				)}
			</div>
		</Paper>
	);
};

export default React.memo(Widget6);
